import { routes } from 'lane-shared/config';
import { simpleDate } from 'lane-shared/helpers/formatters';

import { ClientTask } from 'graphql-query-contracts';

const EMPTY_COMPLETED_DATE = '-';

type BuildTaskDetailsViewModelParams = {
  task?: ClientTask;
  createdUser?: { name?: string | null } | null;
  channelSlug: string;
  canViewAllTasks: boolean;
  hasScheduleAccess: boolean;
};

export function buildTaskDetailsViewModel({
  task,
  createdUser,
  channelSlug,
  canViewAllTasks,
  hasScheduleAccess,
}: BuildTaskDetailsViewModelParams) {
  const taskListRoute = canViewAllTasks
    ? routes.channelAdminWorkOrdersPMTasks
    : routes.channelStaffWorkOrdersPMTasks;

  const scheduleId = task?.schedule?.id;

  return {
    taskListPath: taskListRoute.replace(':id', channelSlug),
    userFriendlyId: task?.userFriendlyID,
    createdOn: simpleDate(task?.createdAt),
    creatorName: createdUser?.name,
    serviceRequestLinks: (task?.serviceRequests ?? []).map(serviceRequest => ({
      id: serviceRequest.serviceRequestId,
      userFriendlyId: serviceRequest.userFriendlyID,
      path: routes.channelAdminWorkOrdersServiceRequestDetails
        .replace(':id', channelSlug)
        .replace(':serviceRequestId', serviceRequest.serviceRequestId),
    })),
    schedule: scheduleId
      ? {
          title: task?.schedule?.title,
          path: hasScheduleAccess
            ? routes.channelAdminWorkOrdersPMScheduleDetails
                .replace(':id', channelSlug)
                .replace(':scheduleId', scheduleId)
            : null,
        }
      : null,
    shouldDisplayLocation: task?.equipment?.length === 0,
    location: task?.location,
    repeatsLabel: task?.repeats?.label,
    estimatedHours: task?.estimateTimeToComplete.toFixed(2),
    dueDate: simpleDate(task?.dueDate),
    completedDate: task?.completedBy
      ? simpleDate(task?.completedAt)
      : EMPTY_COMPLETED_DATE,
    scheduleNotes: task?.scheduleNotes,
    timeAndNotes: {
      hours: task?.hours ?? null,
      minutes: task?.minutes ?? null,
      notes: task?.notes ?? undefined,
    },
  };
}

export type TaskDetailsViewModel = ReturnType<typeof buildTaskDetailsViewModel>;
